import { IDropdownItem } from '../../../../../ui';

export const formatLocationForUrl = (location: IDropdownItem) =>
	location.toString().toLowerCase().replace(/\s/g, '-');

export const getLocationFromUrl = (location: string) =>
	location.replace(/-/g, ' ');
